import { render, staticRenderFns } from "./EditPermissionsButton.vue?vue&type=template&id=7457bdd5&"
import script from "./EditPermissionsButton.vue?vue&type=script&lang=js&"
export * from "./EditPermissionsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports